import { TranslationDictionary } from './types';

export const zhTW: TranslationDictionary = {
    common: {
        title: 'BimEngine',
        description: '這是一個使用 BIM-ENGINE。',
        openTestDialog: '打開測試彈窗',
        openInfoDialog: '打開資訊彈窗 (封裝版)',
    },
    toolbar: {
        home: '首頁',
        measure: '測量',
        zoomBox: '選框放大',
        info: '資訊',
        location: '定位',
        setting: '設定',
        walk: '漫遊',
        map: '地圖',
        property: '構件詳情',
        fullscreen: '全屏',
        walkMenu: '漫遊選單',
        walkPerson: '第一人稱',
        walkBird: '第三人稱',
        tree: '模型樹',
        section: '剖切',
        sectionPlane: '拾取面剖切',
        sectionAxis: '軸向剖切',
        sectionBox: '剖切盒',
        cameraSwitch: '相機切換',
    },
    dialog: {
        testTitle: '測試彈窗',
        testContent: '<div style="padding: 10px;">這是一個 <b>可拖曳</b> 且 <b>可縮放</b> 的彈窗。<br><br>你可以嘗試拖動標題欄，或者拖動右下角改變大小。</div>',
    },
    menu: {
        info: '資訊',
        home: '首頁',
        componentDetail: '構件詳情',
        hideSelected: '隱藏選中構件',
        transparentSelected: '半透明選中構件',
        cancelTranslucent: '取消半透明',
        isolateSelected: '隔離選中構件',
        hideOthers: '其他構件隱藏',
        transparentOthers: '其他構件半透明',
        fitSectionBox: '剖切盒適應',
        showAll: '顯示全部',
        quickSelect: '快速選擇',
        selectSameType: '選擇同類模型',
        selectSameLevel: '選擇同層模型',
        selectSameLevelType: '選擇同層同類模型'
    },
    tree: {
        searchPlaceholder: '請輸入要搜尋的內容',
        noResults: '未找到符合結果',
    },
    constructTree: {
        title: '目錄樹',
    },
    componentTreeDrawer: {
        actions: {
            close: '關閉抽屜',
            add: '新增',
            addPin: '新增圖釘',
            addFolder: '新增文件夾',
            edit: '編輯',
            delete: '刪除',
            save: '保存',
            cancel: '取消'
        },
        tabs: {
            view: '視圖',
            pin: '圖釘',
            constructTree: '構件樹'
        },
        empty: {
            pinTitle: '暫無圖釘',
            pinDesc: '點擊上方按鈕添加第一個圖釘'
        },
        defaultNames: {
            pin: '圖釘',
            folder: '文件夾'
        },
        dialogs: {
            noticeTitle: '提示',
            deleteFolderTitle: '刪除文件夾',
            deleteFolderMessage: '確認刪除該文件夾以及文件夾下面的所有圖釘嗎？',
            deleteFolderMessagePrefix: '是否刪除【',
            deleteFolderMessageSuffix: '】文件夾以及文件夾下面所有的圖釘資料。',
            confirm: '確定'
        },
        placeholders: {
            view: '視圖頁面占位，後續會在這裡接入視圖相關內容。',
            pin: '暫無圖釘，點擊上方按鈕添加',
            constructTree: '構件樹頁面占位，後續會在這裡接入新的構件樹能力。'
        }
    },
    viewTab: {
        category: {
            ceilingPlans: '天花板平面',
            elevations: '立面',
            floorPlans: '樓層平面',
            sections: '剖面',
        },
        empty: '暫無視圖數據',
        default3D: '預設三維',
    },
    tab: {
        component: '構件',
        system: '系統',
        space: '空間',
        type: '類型',
        major: '專業',
    },
    panel: {
        property: {
            title: '構件詳情',
            base: '基本屬性',
            material: '材質資訊',
            advanced: '進階設定',
            tab: {
                props: '屬性',
                material: '材質'
            }
        },
        componentDetail: {
            title: '構件詳情',
            noSelection: '請先選中構件'
        }
    },
    measure: {
        btnName: '測量',
        dialogTitle: '測量',
        modes: {
            clearHeight: '淨高',
            clearDistance: '淨距',
            distance: '距離',
            elevation: '標高',
            point: '座標',
            angle: '角度',
            area: '面積',
            slope: '坡度',
        },
        actions: {
            expand: '展開',
            collapse: '收起',
            clearAll: '刪除全部',
            settings: '設定',
        },
        labels: {
            currentMode: '當前測量方式：',
            x: 'X：',
            y: 'Y：',
            z: 'Z：',
            value: {
                clearHeight: '淨高：',
                clearDistance: '淨距：',
                distance: '距離：',
                elevation: '標高：',
                point: '座標：',
                angle: '角度：',
                area: '面積：',
                slope: '坡度：',
            }
        },
        settings: {
            title: '設定',
            unit: '單位：',
            precision: '精度：',
            hint: '距離、淨距、淨高和標高預設使用該單位；角度和面積有各自預設單位。',
            save: '儲存設定',
            cancel: '取消',
        },
        clearHeight: {
            direction: '朝向：',
            directionDown: '朝下',
            directionUp: '朝上',
            selectType: '選擇對象：',
            selectPoint: '選擇點',
            selectElement: '選擇構件',
        }
    },
    sectionPlane: {
        dialogTitle: '拾取面剖切',
        actions: {
            hide: '隱藏',
            reverse: '反向',
            reset: '重設',
            fill: '填充'
        }
    },
    sectionAxis: {
        dialogTitle: '軸向剖切',
        actions: {
            hide: '隱藏',
            reverse: '反向',
            reset: '重設',
            axisX: 'X',
            axisY: 'Y',
            axisZ: 'Z',
            fill: '填充'
        }
    },
    sectionBox: {
        dialogTitle: '剖切盒',
        actions: {
            hide: '隱藏',
            reverse: '反向',
            fitToModel: '適應',
            reset: '重設',
            fill: '填充'
        },
        axes: {
            x: 'X',
            y: 'Y',
            z: 'Z'
        }
    },
    walkControl: {
        speed: '移動速度：',
        gravity: '重力',
        collision: '碰撞',
        characterModel: {
            label: '建築工人',
            constructionWorker: '建築工人',
            officeMale: '辦公室男性'
        },
        walkMode: {
            label: '行走模式',
            walk: '行走模式',
            run: '奔跑模式'
        },
        exit: '退出',
        path: {
            dialogTitle: '路徑漫遊',
            duration: '漫遊時間',
            durationUnit: '秒',
            loop: '循環播放',
            addPoint: '新增漫遊點',
            deleteAll: '刪除全部',
            point: '漫遊點',
            play: '播放漫遊',
            stop: '停止漫遊',
            noPoints: '暫無漫遊點，請新增'
        }
    },
    info: {
        dialogTitle: '基本資訊',
        meshCount: '構件數量',
        totalTriangles: '三角面數量',
        totalVertices: '頂點數量',
    },
    aiChat: {
        title: 'AI 助手',
        placeholder: '輸入你的問題...',
        quickPrompt: {
            summarize: '總結這個模型',
            explain: '解釋選中的構件',
            generate: '生成報告'
        },
        action: {
            new: '新建對話',
            history: '歷史記錄',
            settings: '設定',
            close: '關閉'
        },
        helper: {
            newline: 'Shift + Enter 換行',
            send: 'Enter 傳送'
        },
        thinking: '正在思考...',
        other: '其他',
        otherPlaceholder: '請輸入自定義答案',
        submit: '提交'
    },
    viewDropdown: {
        triggerTitle: '視圖控制',
        switchOrthographic: '切換到正交視圖',
        switchPerspective: '切換到透視視圖',
        saveMainView: '將當前視圖設為主視圖',
        restoreMainView: '重置主視圖',
        captureScreenshot: '截圖保存',
    },
    setting: {
        dialogTitle: '設定',
        presetSelect: '選擇預設',
        presetSelectPlaceholder: '請選擇預設',
        defaultPresetLabel: '預設預設',
        savePreset: '儲存預設',
        deletePreset: '刪除預設',
        deletePresetForbidden: '預設預設不允許刪除',
        presetDefaultName: '預設',
        presetNamePrompt: '請輸入預設名稱',
        presetNameRequired: '預設名稱不能為空',
        presetNameDuplicate: '預設名稱已存在，請使用其他名稱',
        restorePreset: '還原預設',
        saveAsNewPreset: '另存為新預設',
        selectPresetFirst: '請先選擇預設',
        presetButton: '預設',
        undoChanges: '撤銷修改',
        saveAsDialogTitle: '另存為新預設',
        deleteDialogTitle: '刪除預設',
        deleteDialogMessage: '確認刪除目前預設嗎？刪除後無法復原。',
        presetNamePlaceholder: '請輸入預設名稱',
        confirm: '確定',
        cancel: '取消',
        presetPickPrompt: '請輸入預設序號',
        presetPickInvalid: '預設序號無效',
        renderMode: '渲染模式',
        modes: {
            simple: '效能模式',
            balance: '平衡模式',
            advanced: '效果模式',
        },
        displaySection: '顯示設定',
        edgeLine: '邊線',
        edgeOpacity: '邊線透明度',
        showGrid: '顯示軸網',
        showLevel: '顯示標高',
        contrast: '對比度',
        saturation: '飽和度',
        lightIntensity: '光照強度',
        environment: '環境背景',
        environmentType: {
            none: '無',
            hdr: 'HDR背景',
            sky: '天空盒',
        },
        backgroundVisible: '顯示背景',
        ground: '顯示地面',
        groundElevation: '地面高度',
        groundElevationUnit: 'm',
    },
    help: {
        engineControl: '引擎控制',
        fpsControl: '第一人稱控制',
        gotIt: '好的，知道了',
        dontRemind: '不再提醒我',
        rotate: '旋轉',
        mouseLeftDrag: '滑鼠左鍵拖曳',
        pan: '平移',
        shiftLeftDrag: 'Shift + 左鍵 / 右鍵拖曳',
        zoom: '縮放',
        mouseWheel: '滑鼠滾輪',
        boxSelect: '框選',
        ctrlLeftDrag: 'Ctrl + 左鍵拖曳',
        multiSelect: '加選 / 減選',
        ctrlShiftClick: 'Ctrl + 點擊 (加) / Shift + 點擊 (減)',
        homeView: '回到主視圖',
        doubleClickBlank: '雙擊空白區域',
        rotateRuleTitle: '旋轉點變換規則',
        rotateRuleDesc: '滑鼠懸停構件時，按當前位置設定旋轉中心；懸停空白區域時，保持上一次旋轉中心。',
        roam: '漫遊',
        or: '或',
        upDown: '向上和向下移動',
        qeKey: 'Q / E',
        landOnFloor: '開啟重力將落在最近樓層',
        run: '運行 (加速)',
        shiftArrow: 'Shift + 方向鍵',
        teleport: '傳送',
        doubleClick: '雙擊目標',
        lookAround: '環視',
        leftDrag: '使用左鍵拖動視圖',
        adjustSpeed: '調整速度',
        rotateView: '旋轉視圖',
        panView: '平移視圖',
        zoomView: '縮放視圖',
        resetView: '視圖復位',
        mouseLeftDragShort: '滑鼠左鍵拖曳',
        mouseRightDragShort: '滑鼠右鍵拖曳/Shift+左鍵',
        mouseWheelShort: '滾動滑鼠滾輪',
        componentSelect: '構件選擇',
        click: '點擊',
        addSelect: '加選構件',
        removeSelect: '減選構件',
        doubleClickBlankShort: '雙擊空白區域',
        pointToComponent: '指向構件：',
        pointToComponentDesc: '以滑鼠點擊位置為旋轉中心',
        pointToBlank: '指向空白：',
        pointToBlankDesc: '保持上一次確定的旋轉中心',
        roamMove: '漫遊移動',
        roamMoveDesc: '使用 WASD 鍵進行移動',
        speedUp: '加速移動',
        lookAroundDesc: '左鍵拖動視圖查看四周',
        teleportDesc: '雙擊目標構件或地面',
    }
};
